import { setLocalStore, getLocalStore } from '../../utils/local-store';

export default {
  namespaced: true,
  state: {
    // 用户信息
    userInfo: getLocalStore('user_info'),
    // 权限集合
    permissions: getLocalStore('permissions'),
    // 令牌
    token: getLocalStore('token'),
    // 刷新令牌
    refreshToken: getLocalStore('refresh_token'),
  },
  mutations: {
    SET_USER_INFO(state, userInfo) {
      state.userInfo = userInfo;
      setLocalStore('user_info', userInfo);
    },
    SET_PERMISSIONS(state, permissions) {
      state.permissions = permissions;
      setLocalStore('permissions', permissions);
    },
    SET_TOKEN(state, token) {
      state.token = token;
      setLocalStore('token', token);
    },
    SET_REFRESH_TOKEN(state, refreshToken) {
      state.refreshToken = refreshToken;
      setLocalStore('refresh_token', refreshToken);
    },
  },
  actions: {
    // 登录后，记录数据
    login({ commit }, loginData) {
      commit('SET_TOKEN', loginData.access_token);
      commit('SET_REFRESH_TOKEN', loginData.refresh_token);
      commit('SET_USER_INFO', loginData.user_info);
      commit('SET_PERMISSIONS', loginData.user_info.authorities || []);
    },
  },
};
